import { BetTypeEnum } from "src/constants/enums/betType";

import SingleEmptyState from "src/assets/images/single_empty_state.png";
import SingleEmptyStateLight from "src/assets/images/single_empty_state_light.png";

import MultipleEmptyState from "src/assets/images/multiple_empty_state.png";
import MultipleEmptyStateLight from "src/assets/images/multiple_empty_state_light.png";

import SystemEmptyState from "src/assets/images/system_empty_state.png";
import SystemEmptyStateLight from "src/assets/images/system_empty_state_light.png";

export const emptyStateMap = {
	[BetTypeEnum.Single]: {
		image: SingleEmptyState,
		imageLight: SingleEmptyStateLight,
		text: "You need to add selection to betslip to be able to place a single bet.",
	},

	[BetTypeEnum.Multiple]: {
		image: MultipleEmptyState,
		imageLight: MultipleEmptyStateLight,
		text: "You need at least 2 selections in your betslip to be able to place a combination bet.",
	},

	[BetTypeEnum.System]: {
		image: SystemEmptyState,
		imageLight: SystemEmptyStateLight,
		text: "You need at least 3 selections in your betslip to be able to place a system bet.",
	},

	[BetTypeEnum.Chain]: {
		image: SystemEmptyState,
		imageLight: SystemEmptyStateLight,
		text: "You need at least 2 selections in your betslip to be able to place a chain bet.",
	},
};
